export enum Integration {
	GOOGLE_SERVICE = 'google-invites',
	MICROSOFT_SERVICE = 'microsoft-invites',
	PLATFORM_SLACK_SERVICE = 'slack',
}

export type GenericIntegrations =
	| typeof Integration.MICROSOFT_SERVICE
	| typeof Integration.GOOGLE_SERVICE;

export enum ScopeState {
	NO_SCOPE = 'no-scope',
	PARTIAL_SCOPE = 'partial-scope',
	FULL_SCOPE = 'full-scope',
}

export type SlackWorkspace = {
	avatar: string;
	id: string;
	name: string;
};

export type GenericIntegrationMetadata = {
	scopeState: ScopeState;
};

export type SlackIntegtationMetadataTeam = GenericIntegrationMetadata & SlackWorkspace;

export type SlackIntegtationMetadata = {
	teams: SlackIntegtationMetadataTeam[];
};

export type IntegrationMetadata = {
	[id in GenericIntegrations]?: GenericIntegrationMetadata;
} & {
	[Integration.PLATFORM_SLACK_SERVICE]?: SlackIntegtationMetadata;
};

export interface IntegrationsResponse {
	connectedIntegrations: Integration[];
	enabledIntegrations: Integration[];
	integrationMetadata?: IntegrationMetadata;
}

export type IntegrationsScopeState = {
	noScope: Set<Integration>;
	partialScope: Set<Integration>;
};

export interface OrgSettings {
	is3rdPartyInvitesEnabled?: boolean;
	isSlackImportedInvitesEnabled?: boolean;
}
